export const sameDates = (a, b) =>
  new Date(a).getTime() === new Date(b).getTime() || (!a && !b)
